import { useLocalThemeContext } from '../context';
import { HTMLMotionProps, LayoutGroup, motion } from 'framer-motion';

interface SegmentedControlProps extends Pick<HTMLMotionProps<'div'>, 'className' | 'onLayoutAnimationComplete'> {
  items: Array<string>;
  setItem: (idx: number) => void;
  activeItemIndex?: number;
  activeItemLayoutId?: string;
}

export const SegmentedControlAnimated = ({
  items,
  setItem,
  activeItemIndex,
  activeItemLayoutId = 'SegmentedControlActive',
  className,
  onLayoutAnimationComplete,
}: SegmentedControlProps): JSX.Element => {
  const { colorPalette } = useLocalThemeContext();

  return (
    <div className={className}>
      <LayoutGroup>
        <ol className="grid w-max grid-flow-col rounded-full bg-darkMode-gray-medium/10 p-1">
          {items.map((item, i) => {
            const isActive = i === activeItemIndex;
            return (
              <motion.li layout key={item}>
                <button
                  type="button"
                  onClick={() => setItem(i)}
                  className="relative m-0 h-10 rounded-3xl px-5 py-3 text-[15px] font-bold leading-none text-palette-600"
                >
                  <motion.span
                    className="relative z-[1]"
                    transition={{ ease: 'easeInOut' }}
                    initial={{ color: colorPalette?.[600] }}
                    animate={isActive ? { color: colorPalette?.[1100] } : { color: colorPalette?.[600] }}
                  >
                    {item}
                  </motion.span>
                  {isActive && (
                    <motion.div
                      onLayoutAnimationComplete={onLayoutAnimationComplete}
                      transition={{ damping: 50, stiffness: 500, mass: 1 }}
                      layoutId={activeItemLayoutId}
                      className="absolute inset-0 flex items-center justify-center rounded-3xl bg-palette-600 text-[15px] font-bold text-darkMode-almostBlack"
                    />
                  )}
                </button>
              </motion.li>
            );
          })}
        </ol>
      </LayoutGroup>
    </div>
  );
};
